// constants used in reducer
export const SET_LANGUAGE = 'SET_LANGUAGE'



// WEBPACK FOOTER //
// ./src/redux/constants.js